import React from 'react';
import {Breadcrumb} from 'antd';
import {Link} from 'react-router';

class BreadcrumbToolbar extends React.Component {
  render() {
    const items = this.props.items || []
    return (<Breadcrumb>
      {
        items.map((item, i) => {
          if (item.Link) {
            return <Breadcrumb.Item key={i + 1}>
              <Link to={item.Link}>{item.Name}</Link>
            </Breadcrumb.Item>
          } else {
            return <Breadcrumb.Item key={i + 1}>{item.Name}</Breadcrumb.Item>
          }
        })
      }
    </Breadcrumb>)
  }
}

export default BreadcrumbToolbar;



// WEBPACK FOOTER //
// ./src/components/layouts/BreadcrumbToolbar.js